import React from 'react';
import { useEffect } from 'react';

// @shared/components
import VerticalTab from '../../../../shared/components/Tabs/VerticalTab';

// components
import Statement from '../../Statement/Statement';
import Billing from '../../Billing/Billing';
import Membership from '../Membership/Membership';
import PaymentMethods from '../../Billing/PaymentMethods/PaymentMethods';

import { eventData, eventTracker } from '../../../../shared/components/EventTracker/EventTracker';
//SDK
import { MEMBERSHIP_TYPE } from '@sdk-point/talisis'; 

const PaymentInfo = (props) => {
    const [activeTabIndex,setActiveTabIndex]=React.useState(0);
    const [activePaymentInfoTab,setActivePaymentInfoTab]=React.useState(0);
    const TABINDEX=3;
    const labels = [];
    const panels = [];

    const isCurrentTab=(val)=>{
        return activeTabIndex===TABINDEX && activePaymentInfoTab===val?true:false;
    };

    const membershipType = props?.props?.user?.membership_type_id;
    if (MEMBERSHIP_TYPE.STANDARD === membershipType|| MEMBERSHIP_TYPE.SCHOLAR === membershipType) {
        labels.push({ icon: <i className="ri-contacts-line"></i>, title: 'Estado de cuenta'})
        labels.push({ icon: <i className="ri-money-dollar-circle-line"></i>, title: 'Mis adeudos'})
        panels.push(<Statement isCurrentTab={isCurrentTab(0)} />)
        panels.push(<Billing isCurrentTab={isCurrentTab(1)} />)

    }
    
    labels.push({ icon: <i className="ri-user-star-line icon"></i>, title: 'Membresías' })
    panels.push(<Membership isCurrentTab={isCurrentTab(2)} />)
    
    if (MEMBERSHIP_TYPE.STANDARD === membershipType) {
        labels.push({ icon: <i className="ri-wallet-line icon"></i>, title: 'Métodos de pago' })
        panels.push(<PaymentMethods isCurrentTab={isCurrentTab(3)} />)
    }

    useEffect(() => {
        eventTracker('s_estado_cuenta',eventData, ['mixpanel']);
    }, []);

    
    useEffect(()=>{
        setActiveTabIndex(props.props.activeTabIndex);
      },[props.props.activeTabIndex]);

    return (
        <VerticalTab labels={labels} panels={panels} setActivePaymentInfoTab={setActivePaymentInfoTab} selected={props.props.activeSubTabIndex}/>
    )
};

export default PaymentInfo;